import Api from '@api/decoration'
import { isSiDaProperty } from '@merchant-backend/util'
import { getMerchantInfo } from '@util'
import { computed, observable } from 'mobx'

class Store {
  constructor(homeStore) {
    this.homeStore = homeStore
  }

  @observable totalAll = 0
  @observable updates = {}

  /**
   * 商家动态
   */
  getMerchantUpdates = async (type = '', changeTotalCount = true) => {
    let params = { type }

    if (isSiDaProperty()) {
      params = {
        ...params,
        merchant_id: getMerchantInfo().id,
        per_page: 6
      }
    } else {
      params = {
        ...params,
        per_page: 1
      }
    }
    const { data } = await Api.merchantUpdates(params)
    this.updates = data || {}

    if (changeTotalCount) {
      this.totalAll = this.updates.total_count
    }
  }

  @computed
  get showMerchantUpdates() {
    return (
      this.homeStore.mode === 'editable' ||
      (this.homeStore.mode === 'preview' && this.totalAll > 0)
    )
  }
}

export default Store
